import { fetchMigrationStatus } from './fetchMigrationStatus.tsx';
import type { CmdbArchitectureStoreAction } from './ContainerProps.types.tsx';

export const fetchInitialStatus =
	(): CmdbArchitectureStoreAction =>
	({ getState, dispatch }) => {
		if (!getState().loading && !getState().migrationStatus) {
			dispatch(fetchMigrationStatus());
		}
	};
